export default [

    {
        path: "/",
        name: "home",
        component: ()=>import("@/views/home/index")
    },
    {
        path: "*",
        name: "404",
        component: ()=>import("@/views/notFound")
    },
    {
        path: "/test",
        name: "test",
        component: ()=>import("@/views/test")
    },
    {
        path: "/download",
        name: "download",
        component: ()=>import("@/views/download")
    }
]